module.exports = __webpack_public_path__ + "wechat-static/img/notice.f8414bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notice.png
// module id = 6RTL
// module chunks = 1